import React from 'react';
import { MarketAccessory, MarketRow } from '@market/react';

interface StepRowProps {
  label: string;
  Icon: React.FC;
}

export default function StepRow({ label, Icon }: StepRowProps) {
  return (
    <MarketRow>
      <label slot="label">{label}</label>
      <MarketAccessory size="icon" slot="leading-accessory">
        <Icon />
      </MarketAccessory>
    </MarketRow>
  );
}
